class BannerVideo {
	constructor(el) {
		this.el = el;
		this.iframe = this.el.querySelector('iframe');

		if (this.iframe.tagName.toLowerCase() === 'iframe') {
			this.setupIframe();
		} else {
			console.warn('BannerVideo: The element is not an iframe. Please provide a valid iframe element.');
		}
	}

	setupIframe() {
		const {iframe} = this;
		let src = iframe.getAttribute('src');

		if (src) {
			if (src.includes('youtube.com')) {
				src += (src.includes('?') ? '&' : '?') + 'autoplay=1&mute=1&loop=1';
				const playlistMatch = src.match(/list=([a-zA-Z0-9_-]+)/);
				if (playlistMatch) {
					src += `&playlist=${playlistMatch[1]}`;
				}
				src += '&vq=hd1080'; // Suggest highest quality
			} else if (src.includes('vimeo.com')) {
				src += (src.includes('?') ? '&' : '?') + 'autoplay=1&muted=1&loop=1&quality=1080p';
			} else {
				console.warn('BannerVideo: The iframe source is not a recognized YouTube or Vimeo URL.');
			}

			// Set updated src and allow attributes
			iframe.setAttribute('src', src);
			iframe.setAttribute('allow', 'autoplay; fullscreen'); // Allow autoplay and fullscreen
		} else {
			console.warn('BannerVideo: The iframe does not have a src attribute.');
		}
	}
}

export default BannerVideo;